module.exports = __webpack_public_path__ + "static/img/77071F_4_R_20200801_LC.8ee3ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77071F_4_R_20200801_LC.png
// module id = pgzT
// module chunks = 0